import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center font-medium text-base text-gray-900 px-5 py-2 bg-white border border-gray-300 shadow rounded" }
const _hoisted_2 = { class: "md:text-18" }
const _hoisted_3 = { class: "select-none text-gray-500 flex flex-row items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-r border-gray-300 h-10 mx-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationButton = _resolveComponent("PaginationButton")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, " Showing " + _toDisplayString((_ctx.modelValue - 1) * _ctx.pageSize + 1) + "-" + _toDisplayString(_ctx.pagesList.length === _ctx.modelValue ? _ctx.length : _ctx.modelValue * _ctx.pageSize) + " of " + _toDisplayString(_ctx.length) + " " + _toDisplayString(_ctx.itemsName), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedList, (page) => {
        return (_openBlock(), _createBlock(_component_PaginationButton, {
          key: page,
          active: _ctx.modelValue === page,
          disabled: !page,
          "data-dusk": `copd-pagination-button-${page}`,
          onClick: ($event: any) => (_ctx.updatePage(page))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(page ? page : '...'), 1)
          ]),
          _: 2
        }, 1032, ["active", "disabled", "data-dusk", "onClick"]))
      }), 128)),
      _hoisted_4,
      _createVNode(_component_PaginationButton, {
        disabled: _ctx.modelValue === 1,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.previousPage()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseIcon, { name: "arrow-left" })
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_PaginationButton, {
        disabled: _ctx.modelValue === _ctx.pagesList.length,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPage()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BaseIcon, { name: "arrow-right" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}